import { useContext } from 'react'
import DarkModeContext from './DarkModeContext'

const useDarkMode = () => useContext(DarkModeContext)

export default useDarkMode
